/**
 * The Maintenance detail tabs. The shell renders them in its Tabs.Root; bind
 * that root to useTwinUi.tab and setTab so the chart icons, the report's
 * spec-sheet action and the HUD procedure strip can switch tabs.
 */
import type { ReactNode } from 'react';
import { HealthPanel } from './panels/HealthPanel';
import { PartsPanel } from './panels/PartsPanel';
import { ProceduresPanel } from './panels/ProceduresPanel';
import { ReadingsPanel } from './panels/ReadingsPanel';
import { ReportTab } from './panels/ReportTab';

export const TWIN_TABS: Array<{ key: string; label: string; render: () => ReactNode }> = [
  { key: 'health', label: 'Health', render: () => <HealthPanel /> },
  { key: 'readings', label: 'Readings', render: () => <ReadingsPanel /> },
  { key: 'procedures', label: 'Procedures', render: () => <ProceduresPanel /> },
  { key: 'parts', label: 'Parts', render: () => <PartsPanel /> },
  { key: 'report', label: 'Report', render: () => <ReportTab /> },
];
